module.exports = __webpack_public_path__ + "static/media/croquette.544c383d.png";